// extracted by mini-css-extract-plugin
export var subtitle = "_dl-2";
export var title = "_dl-0";
export var titleNoWrap = "_dl-1";